import DV from 'ts-data-validator';

import catalogConstants    from './catalog.constants';
import catalogInitialState from './catalog.state';

function catalogReducer(state = catalogInitialState, action) {
  let offers = {};

  switch (action.type) {
    case catalogConstants.CATALOG_GET_ITEMS_REQUEST:
    case catalogConstants.CATALOG_GET_ITEM_BY_SERIES_REQUEST:
    case catalogConstants.CATALOG_GET_ITEM_REQUEST:
    case catalogConstants.CATALOG_SHOW_MORE_REQUEST:
    case catalogConstants.CATALOG_FILTER_GET_INITIAL_STATE_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case catalogConstants.CATALOG_SET_SORT_REQUEST:
      state = {
        ...state,
        catalog: {
          ...state.catalog,
          sort: action.sort,
        },
        loading: true,
      };
      break;

    case catalogConstants.CATALOG_GET_ITEMS_SUCCESS:
      state = {
        ...state,
        catalog: {
          ...state.catalog,
          count:              DV.isNumber(action.count) ? action.count : state.catalog.count,
          countModels:        +action.countModels ?? state.catalog.countModels,
          initialStateLoaded: true,
          installationTypes:  action.installationTypes || state.catalog.installationTypes,
          isInterior:         action.isInterior,
          items:              action.items,
          meta:               action.meta || state.catalog.meta,
          modelCount:         +action.modelCount || state.catalog.modelCount,
          popularModels:      action.popularModels || state.catalog.popularModels,
          showMore:           action.items?.length > 0,
          sort:               (
                                action.selectedValues || {}).sort || state.catalog.sort,
        },
        filter:  {
          ...state.filter,
          filter:         action.filter || state.filter,
          selectedValues: {
            ...(
              action.selectedValues || catalogInitialState.filter.selectedValues),
          },
        },
        loading: !state.filter.initialStateLoaded,
      };
      break;

    case catalogConstants.CATALOG_SET_SORT_SUCCESS:
      state = {
        ...state,
        catalog: {
          ...state.catalog,
          items:    [...action.items],
          // сортировка меняет url (см. history.push в catalog.provider.js) —
          // meta для нового url должна обновиться вместе с items, иначе
          // canonical/robots остаются от предыдущего состояния фильтра
          meta:     action.meta || state.catalog.meta,
          showMore: action.items.length > 0,
          sort:     action.sort || state.sort,
        },
        loading: false,
      };
      break;

    case catalogConstants.CATALOG_SHOW_MORE_SUCCESS:
      state = {
        ...state,
        catalog: {
          ...state.catalog,
          items:    [
            ...action.items,
          ],
          meta:     action.meta || state.catalog.meta,
          showMore: action.items.length > 0,
        },
        loading: false,
      };
      break;

    case catalogConstants.CATALOG_FILTER_GET_INITIAL_STATE_SUCCESS:
      state = {
        ...state,
        filter:  {
          ...state.filter,
          filter:             action.filter || {},
          initialStateLoaded: true,
          selectedValues:     action.selectedValues || {},
        },
        loading: !state.catalog.initialStateLoaded,
      };
      break;

    case catalogConstants.CATALOG_GET_ITEM_SUCCESS:
    case catalogConstants.CATALOG_GET_ITEM_BY_SERIES_SUCCESS:
      offers = {};

      action.offers.map(({
        common = {},
        sections = [],
      }) => {
        offers = {
          ...offers,
          [`${common.offerId}`]: {
            common:                    {
              // here add keys (insertsIN, insertsOUT)
              backSideImage:      common.backSideImage,
              backSideImageAlt:   common.backSideImageAlt || '',
              cities:             common.cities || [],
              constructionTypeId: +common.constructionTypeId,
              description:        common.description,
              discountPercent:    common.discountPercent,
              discountPrice:      !!common.discountPrice ? +common.discountPrice : null,
              ecommerce:          common.ecommerce,
              frontSideImage:     common.frontSideImage,
              frontSideImageAlt:  common.frontSideImageAlt || '',
              installationTypeId:     +common.installationTypeId,
              installationTypeUrlKey: common.installationTypeUrlKey,
              interiorImage:          common.interiorImage,
              insertColorInside:  common.insertColorInside,
              insertColorOutside: common.insertColorOutside,
              isMarker:           common.isMarker,
              isExpressMarker:    common.isExpressMarker || false,
              isSpecMarker:       common.isSpecMarker || false,
              isInterior:         common.isInterior,
              internalOpening:    common.internalOpening,
              label:              common.label,
              meta:               common.meta,
              modelId:            +common.modelId,
              moreInfoLink:       common.moreInfoLink,
              markerLabel:        common.markerLabel,
              moreInfo:           common.moreInfo,
              mark:               common.mark,
              notAvailable:       common.notAvailable || false,
              offerGroupId:       +common.offerGroupId,
              offerId:            +common.offerId,
              price:              !!common.price ? +common.price : null,
              regions:            common.regions || [],
              seriesId:           +common.seriesId,
              sortPrice:          +common.sortPrice || +common.discountPrice || +common.price,
              showDiscountPrice:  common.showDiscountPrice,
              singleSideView:     common.singleSideView,
              tags:               common.tags || [],
              updatedAt:          common.updatedAt,
              urlKey:             common.urlKey,
              vendorCode:         common.vendorCode,
            },
            sections:                  sections,
          },
        };
      });

      if (action.hasOwnProperty('sliderImage') && !DV.isNull(action.sliderImage) && DV.isNotEmptyObject(action.sliderImage)) {
        for (let offer in action.sliderImage) {
          if (action.sliderImage.hasOwnProperty(offer)) {
            if (DV.isNotEmptyArray(action.sliderImage[offer])) {
              offers[offer].common.gallery = [...action.sliderImage[offer]];
            }
          }
        }
      }

      state = {
        ...state,
        element: {
          ...state.element,
          allowedSeries:        {
            ...state.element.allowedSeries,
            [`${action.currentModelId}`]: { ...action.allowedSeries },
          },
          currentModelId:       +action.currentModelId,
          currentOfferGroupId:  +action.currentOfferGroupId,
          currentOfferId:       +action.currentOfferId,
          currentSeriesId:      +action.currentSeriesId,
          initialStateLoaded:   true,
          lowPrioritySeriesKey: action.lowPrioritySeriesKey || false,
          models:               {
            ...state.element.models,
            [`${action.currentModelId}`]: {
              ...(
                state.element.models[action.currentModelId] || {}),
              [`${action.currentSeriesId}`]: { ...offers },
            },
          },
          popularModels:        action.popularModels || state.element.popularModels,
          stb:                  {
            ...state.element.stb,
            max:    {
              coldProtection:  +action.maxStandard.coldProtection || state.element.stb.max.coldProtection,
              draftProtection: +action.maxStandard.draftProtection || state.element.stb.max.draftProtection,
              security:        +action.maxStandard.security || state.element.stb.max.security,
              soundInsulation: +action.maxStandard.soundInsulation || state.element.stb.max.soundInsulation,
            },
            series: {
              ...state.element.stb.series,
              [`${action.currentSeriesId}`]: {
                coldProtection:  +action.seriesStandard.coldProtection || null,
                draftProtection: +action.seriesStandard.draftProtection || null,
                security:        +action.seriesStandard.security || null,
                soundInsulation: +action.seriesStandard.soundInsulation || null,
              },
            },
          },
        },
        loading: false,
      };

      break;

    case catalogConstants.CATALOG_GET_ITEMS_FAILURE:
    case catalogConstants.CATALOG_GET_ITEM_FAILURE:
    case catalogConstants.CATALOG_GET_ITEM_BY_SERIES_FAILURE:
    case catalogConstants.CATALOG_SET_SORT_FAILURE:
    case catalogConstants.CATALOG_SHOW_MORE_FAILURE:
    case catalogConstants.CATALOG_FILTER_GET_INITIAL_STATE_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case catalogConstants.CATALOG_FILTER_SET_PARAM:
      let selectedValues = { ...state.filter.selectedValues };

      if (selectedValues.hasOwnProperty(action.param) && selectedValues[action.param] === action.param) {
        delete selectedValues[action.param];
      } else if (action.param === 'mt' || action.param === 'sc') {
        selectedValues = {
          ...selectedValues,
          [`${action.param}`]: selectedValues[action.param] ? selectedValues[action.param].includes(action.value)
            ? [...selectedValues[action.param].filter(param => param !== action.value)]
            : [
              ...selectedValues[action.param],
              action.value,
            ] : [action.value],
        };
      } else {
        selectedValues = {
          ...selectedValues,
          [`${action.param}`]: action.value,
        };
      }

      state = {
        ...state,
        filter: {
          ...state.filter,
          selectedValues: { ...selectedValues },
        },
      };
      break;

    case catalogConstants.CATALOG_RESET_INITIAL_STATE:
      state = {
        ...state,
        catalog: { ...catalogInitialState.catalog },
        loading: false,
        wait:    false,
      };
      break;

    case catalogConstants.CATALOG_ELEMENT_RESET:
      state = {
        ...state,
        element: {
          ...state.element,
          initialStateLoaded: false,
        },
      };
      break;

    case catalogConstants.CATALOG_FILTER_RESET:
      state = {
        ...state,
        filter: {
          ...state.filter,
          selectedValues: { ...catalogInitialState.filter.selectedValues },
        },
      };
      break;

    case catalogConstants.CATALOG_FILTER_SHOW:
      state = {
        ...state,
        filter: {
          ...state.filter,
          open: true,
        },
      };
      break;

    case catalogConstants.CATALOG_FILTER_HIDE:
      state = {
        ...state,
        filter: {
          ...state.filter,
          open: false,
        },
      };
      break;

    case catalogConstants.CATALOG_RESET_SORT:
      state = {
        ...state,
        catalog: {
          ...state.catalog,
          sort: null,
        },
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default catalogReducer;